import ConfirmCodeForm from './ConfirmCodeForm';

export default ConfirmCodeForm;


// WEBPACK FOOTER //
// ./src/components/forms/ConfirmCodeForm/index.js